import { render, staticRenderFns } from "./TakeOrder.vue?vue&type=template&id=1c498a8e&"
import script from "./TakeOrder.vue?vue&type=script&lang=js&"
export * from "./TakeOrder.vue?vue&type=script&lang=js&"
import style0 from "./TakeOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports